
















import { capitalize } from '@getaccept/lib-shared/src/helpers';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { computed, defineComponent, toRefs, watch } from '@vue/composition-api';
import DashboardWidget from '../../../../components/DashboardWidget.vue';
import { DashboardWidgetHeaderColor } from '../../../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../../../types/enums/dashboard-widget-value-color';
import { useWidgetStore } from '../../store/widget.store';
import { useActiveDealTimesData } from '../composables/active-deal-times-data.composable';

export default defineComponent({
  name: 'AverageDealTimeWidget',
  components: {
    DashboardWidget,
  },
  props: {
    showAll: {
      type: Boolean,
    },
  },
  setup(props) {
    const widgetStore = useWidgetStore();
    const { showAll } = toRefs(props);
    const { currentData, previousData, isLoading, isSuccess } = useActiveDealTimesData(showAll);

    const calculateAverageCloseDays = (currentDays: number, previousDays: number) => {
      let days = 30;
      if (currentDays > 0 && previousDays > 0) {
        days = Math.ceil(currentDays + previousDays) / 2;
      } else if (previousDays > 0) {
        days = previousDays;
      } else if (currentDays > 0) {
        days = currentDays;
      }
      widgetStore.setAverageDealCloseDays(days);
    };

    watch(isSuccess, () => {
      calculateAverageCloseDays(currentData.value?.days || 0, previousData.value?.days || 0);
    });

    const dealtimeValue = computed(() => {
      if (!currentData.value) {
        return 0;
      }
      return currentData.value.days > 2 ? currentData.value.days : currentData.value.hours;
    });

    const dealtimeTitle = computed(() => {
      if (!currentData.value) {
        return '';
      }
      return currentData.value.days > 2
        ? t('days')
        : currentData.value.hours === 1
        ? t('Hour')
        : t('Hours');
    });

    const dealtimeLastValue = computed(() => {
      if (!previousData.value) {
        return '';
      }
      return previousData.value.days > 2
        ? `${previousData.value.days} ${t('days')}`
        : previousData.value.hours === 1
        ? `${previousData.value.hours} ${t('Hour')}`
        : `${previousData.value.hours} ${t('Hours')}`;
    });

    return {
      dealtimeValue,
      dealtimeTitle,
      dealtimeLastValue,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
      capitalize,
      isLoading,
      isSuccess,
    };
  },
});
